// extracted by mini-css-extract-plugin
module.exports =  {"labels":"_93444fe79c--labels--LepFl","label":"_93444fe79c--label--_xCqT","vertical":"_93444fe79c--vertical--QK27q"};